// React
import { useEffect } from "react";

// OpenLayers
import OlMap from "ol/Map";
import { ScaleLine as OlScaleLine } from "ol/control";
import { Units } from "ol/control/ScaleLine";

// UI
import ScaleUnitPopup from "views/popups/ScaleUnitPopup";

// Tools
import { getOffsetBottomPixels } from "lib/utilities/misc";

// jQuery
import $ from "jquery";

import "styles/css/ScaleLine.scss";

interface ScaleBarProps {
	olMap:OlMap
}

var scaleLine:OlScaleLine;

export default function ScaleLine({olMap}:ScaleBarProps) {
	// Initialize
	useEffect(() => {
		const defaultUnits:string = _config.defaultScaleLineUnits;
		
		if(_config.scaleUnitOptions.indexOf(defaultUnits) < 0)
			throw new Error(`Invalid scale bar units '${defaultUnits}'`);
		
		const unit:Units = defaultUnits as Units;
		
		scaleLine = new OlScaleLine({
			units: unit,
			maxWidth: 90,
			target: "scale-line"
		});
		
		olMap.getControls().extend([scaleLine]);
		olMap.set("scale-line", scaleLine);
		
		// Set the units of the scale line on the global UI for easy reference elsewhere
		_ui.setScaleLineUnits(scaleLine.getUnits(), true);
		
		// Relies on #scale-line being available
		setTimeout(() => adjust(), 100);
		setTimeout(() => adjust(), 250);
		setTimeout(() => adjust(), 500);
	}, [olMap]);
	
	// On dimensions changed
	useEffect(() => {
		adjust();
	}, [_dimensions]);
	
	const adjust = () => {
		const width:number = _dimensions.width;
		const height:number = _dimensions.height;
		
		if(width < 340)
			$("#scale-line").fadeOut(_ui.transitionDownOptions);
		else
			$("#scale-line").fadeIn(_ui.transitionUpOptions);
			
		const paddingLeft:number = ($("#base-map-switcher").position()?.left || 40) + (_dimensions.width > 400 ? 15 : 10);
		const left:number = $("#base-map-switcher").width() + paddingLeft;
		
		$("#scale-line").css("left", left);
		
		const bmBottom:number = getOffsetBottomPixels("#base-map-switcher");
		
		if(bmBottom) {
			$("#scale-line").css("bottom", (bmBottom-5) + "px");
		}
	}
	const onScaleLineClicked = (e:any) => {
		e.preventDefault();
		
		const scaleUnitOptions:Array<string> = _config.scaleUnitOptions;
		
		ScaleUnitPopup.set("map", olMap);
		ScaleUnitPopup.set("unit-options", scaleUnitOptions);
		
		_ui.showPopup(ScaleUnitPopup);
	}
	
	return (
		<div id="scale-line" className="scale-line" onClick={onScaleLineClicked}></div>
	);
}